import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, useAppDispatch, useAppSelector } from '../../base';
import { useEffectOnce } from 'react-use';
import { jobsActions, jobsSelectors } from '../../actions';
import { IStatsCard } from '../../common';
import StatsCardsRow from '../StatsCardsRow';

const JobsPageStatistics: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const statistics = useAppSelector(jobsSelectors.getJobsPageStatistics);
    // const isLoading = useSelector(jobsSelectors.getJobsPageStatisticsLoading);

    useEffectOnce(() => {
        dispatch(jobsActions.fetchJobsPageStatistics());
    });

    const stats: Array<IStatsCard> = [
        {
            icon: <Icon name="CandidatesIcon" size={40} />,
            title: t('jobsPage.totalCandidatesAwaiting'),
            value: statistics?.newApplicants || 0,
            change: {
                value: Math.abs(statistics?.newDifference || 0),
                isPositive: (statistics?.newDifference ?? 0) > 0,
                isZero: statistics?.newDifference === 0,
            },
        },
        {
            icon: <Icon name="RejectedCandidatesIcon" size={40} />,
            title: t('jobsPage.rejectedCandidates'),
            value: statistics?.rejectedApplicants || 0,
            change: {
                value: Math.abs(statistics?.rejectedDifference || 0),
                isPositive: (statistics?.rejectedDifference ?? 0) > 0,
                isZero: statistics?.rejectedDifference === 0,
            },
        },
        {
            icon: <Icon name="ProceededCandidatesIcon" size={40} />,
            title: t('jobsPage.proceededCandidates'),
            value: statistics?.proceededApplicants || 0,
            change: {
                value: Math.abs(statistics?.proceededDifference || 0),
                isPositive: (statistics?.proceededDifference ?? 0) > 0,
                isZero: statistics?.proceededDifference === 0,
            },
        },
        {
            icon: <Icon name="ClockIcon" size={40} />,
            title: t('jobsPage.averageJobOpenings'),
            value: t('jobsPage.averageJobOpeningsValue', {
                days: statistics?.averageJobPublish || 0,
            }),
            //subtitle: 'Updated 10 min ago',
        },
    ];

    return <StatsCardsRow stats={stats} />;
};

export default JobsPageStatistics;
